import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'

import {
  Select, MenuItem, FormControl, InputLabel,
  Grid,
  Box,
  InputAdornment,
  TextField as Input,
  CircularProgress,
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel,
} from '@material-ui/core'

import Widget from '../../components/Widget/Widget'
import { Typography } from '../../components/Wrappers/Wrappers'

import useStyles from "./styles";
import { getSubscribersDatas, useSubscriberUserState } from '../../context/SubscribeContext';

// Icons
import {
  Search as SearchIcon
} from '@material-ui/icons'
import config from "../../config";

//tabs
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import moment from 'moment'

//Function to sort data
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

//Table headings
const headCells = [
  { numeric: true, disablePadding: false, label: '#', sort: false, center: false },
  { id: "name", numeric: true, disablePadding: false, label: "NAME", sort: true, center: false },
  { id: "email", numeric: true, disablePadding: false, label: "EMAIL", sort: true, center: false },
  { id: "role", numeric: true, disablePadding: false, label: "PLAN", sort: true, center: false },
  { id: "date", numeric: true, disablePadding: false, label: "DATE", sort: true, center: false },
];
const headCells2 = [
  { numeric: true, disablePadding: false, label: '#', sort: false, center: false },
  { id: "name", numeric: true, disablePadding: false, label: "NAME", sort: true, center: false },
  { id: "email", numeric: true, disablePadding: false, label: "EMAIL", sort: true, center: false },
  { id: "date", numeric: true, disablePadding: false, label: "DATE", sort: true, center: false },
];

//It will create table heading
function EnhancedTableHead(props) {
  const {
    order,
    orderBy,
    onRequestSort,
    value
  } = props
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }
  return (
    <TableHead>
      <TableRow>
        {(value == "1" ? headCells:headCells2).map((headCell, index) => (
          <TableCell
            width={headCell.width}
            key={index}
            align={headCell.center ? 'center' : headCell.numeric ? 'left' : 'right'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.sort ?
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                <Typography
                  noWrap
                  weight={'medium'}
                  variant={'body2'}
                >
                  {headCell.label}
                </Typography>
              </TableSortLabel>
              :
              <Typography
                noWrap
                weight={'medium'}
                variant={'body2'}
              >
                {headCell.label}
              </Typography>
            }
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

//Users component
const Subscription = () => {
  const classes = useStyles();
  const context = useSubscriberUserState();

  const [order, setOrder] = useState('desc')
  const [orderBy, setOrderBy] = useState('created_date')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [value, setValue] = useState('1');
  const [searchVal, setSearchVal] = useState('');
  const [totalUser, setTotalUser] = useState({
    total: 0,
    subscribed_user: 0,
    unsubscribed_user: 0,
    users: [],
    selected_date: "",
    start_date: "",
    end_date: "",
    plan_filter: "10"
  });

  useEffect(() => {
    setTotalUser((prev) => ({
      ...prev,
      total: context.SubscriberUser.SubscriberUser?.total ? context.SubscriberUser.SubscriberUser?.total : 0,
      subscribed_user: context.SubscriberUser.SubscriberUser?.total_subscribed_user ? context.SubscriberUser.SubscriberUser?.total_subscribed_user : 0,
      users: context.SubscriberUser.SubscriberUser?.users ? context.SubscriberUser.SubscriberUser?.users : []
    }))
  }, [context.SubscriberUser]);

  useEffect(() => {
    getData();
  }, [value, page, totalUser.selected_date, searchVal, totalUser.plan_filter]);

  const getData = async () => {
    if (totalUser.selected_date == "" || totalUser.selected_date == "0") {
      const reqParams = {
        "is_subscribed": value == '1' ? 1 : 0,
        "page": page,
        "limit": rowsPerPage,
        "start_date": new Date('01-01-2022'),
        "end_date": new Date(),
        "search": searchVal.trim(),
        "role": Number(totalUser.plan_filter)
      }
      await getSubscribersDatas(context.setSubscriberUser, reqParams);
    } else {
      if (totalUser.selected_date == '1') {
        const getTodayDate = moment().format('YYYY-MM-DD');
        const startOfTheDay = `${getTodayDate} 00:00:00`
        const endOfTheDay = `${getTodayDate} 23:59:59`
        const reqParams = {
          "is_subscribed": value == '1' ? 1 : 0,
          "page": page,
          "limit": rowsPerPage,
          "start_date": startOfTheDay,
          "end_date": endOfTheDay,
        }
        await getSubscribersDatas(context.setSubscriberUser, reqParams);
      } else if (totalUser.selected_date == '2') {
        const startOfMonth = moment().startOf('month').format('YYYY-MM-DD hh:mm:ss');
        const endOfMonth = moment().endOf('month').format('YYYY-MM-DD hh:mm:ss');
        const reqParams = {
          "is_subscribed": value == '1' ? 1 : 0,
          "page": page,
          "limit": rowsPerPage,
          "start_date": startOfMonth,
          "end_date": endOfMonth,
        }
        await getSubscribersDatas(context.setSubscriberUser, reqParams);
      }
    }
  };

  //Function to store Sort by and property to sort
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  };

  //Function to call when pagination value change
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  };

  //Function to set value of rows per page
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSearch = (event) => {
    setSearchVal(event.target.value);
  };

  const onSelectDateclick = async () => {
    setTotalUser((prev) => ({
      ...prev,
      users: []
    }))
    const reqParams = {
      "is_subscribed": value == '1' ? 1 : 0,
      "page": page,
      "limit": rowsPerPage,
      "start_date": `${totalUser.start_date} 00:00:00`,
      "end_date": `${totalUser.end_date} 23:59:39`,
    }
    await getSubscribersDatas(context.setSubscriberUser, reqParams);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Widget inheritHeight>
          <Grid container spacing={3}>
            <Grid item md={3} xs={3} sm={3}>
              <Typography className={classes.mainPageTitle}><b>Subscription</b></Typography>
            </Grid>
            <Grid md={2} xs={2} sm={2}>
              <Box
                display={'flex'}
                alignItems={'center'}
                justifyContent={'flex-start'}
              >
                <Typography className={classes.subUser}>
                  Number of Subscribed Users: <span className={classes.subUserSpan}>{totalUser.subscribed_user}</span>
                </Typography>
              </Box>
            </Grid>
            <Grid md={4} xs={4} sm={4}>
              <FormControl className={classes.datedropdown}>
                <InputLabel>Filter by Plan</InputLabel>
                <Select value={totalUser.plan_filter} onChange={(e) => { setTotalUser((prev) => ({ ...prev, plan_filter: e.target.value })) }}>
                 {
                  config.subscriptionList.map((item) => {
                    return(
                      <MenuItem value={item.id}>{item.role}</MenuItem>
                    )
                  })
                 }
                </Select>
              </FormControl>
              <FormControl className={classes.datedropdown}>
                <InputLabel>Filter by Date</InputLabel>
                <Select value={totalUser.selected_date} onChange={(e) => { setTotalUser((prev) => ({ ...prev, selected_date: e.target.value })) }}>
                  <MenuItem value={"1"}>Today</MenuItem>
                  <MenuItem value={"2"}>Current Month</MenuItem>
                  <MenuItem value={"3"} data-bs-toggle="modal" data-bs-target="#exampleModal">
                    Date
                  </MenuItem>
                  <MenuItem value={""}>All</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={3} xs={3} sm={3}>
              <Box
                display={'flex'}
                alignItems={'center'}
                justifyContent={'flex-end'}
              >
                <Input
                  fullWidth
                  id="search-field"
                  margin="dense"
                  type='email'
                  placeholder='Search by Name'
                  variant="outlined"
                  onChange={(e) => handleSearch(e)}
                  value={searchVal}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Widget>
      </Grid>

      {!context.SubscriberUser.isLoaded ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          width={"100vw"}
          height={"calc(100vh - 200px)"}
        >
          <CircularProgress size={50} />
        </Box>
      ) : (
        <Widget className={classes.boxContainer} noBodyPadding>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={value} >
              <Box sx={{ borderBottom: 1, borderColor: '#5F8275' }}>{/* //f1981c */}
                <TabList onChange={handleChange} aria-label="lab API tabs example" TabIndicatorProps={{ style: { background: '#2F695F' } }}>{/* //FA991C */}
                  <Tab label="Subscribed" value="1" style={{ color: "#5F8275" }} in />
                  <Tab label="Unsubscribed" value="2" style={{ color: "#5F8275" }} />
                </TabList>
              </Box>
              <TabPanel value="1" style={{ padding: "4px" }}>
                <Widget className={classes.boxContainer} noBodyPadding>
                  <Grid item xs={12}>
                    <Paper className={classes.root}>
                      <TableContainer className={classes.container}>
                        <Table
                          aria-labelledby="tableTitle"
                          aria-label="enhanced table">
                          <EnhancedTableHead
                            value={value}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                          // rowCount={users.data.length}
                          />
                          <TableBody>
                            {
                              totalUser.users.length > 0 ?
                                totalUser.users.map((item, index) => {
                                  return (
                                    <TableRow key={index}>
                                      <TableCell
                                        // component="th"
                                        scope="row"
                                        // padding='10px'
                                        width={'10px'}
                                        className={classes.cell}
                                      >
                                        <Typography variant={'body2'}>
                                          {(page * rowsPerPage) + index + 1}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant={'body2'} style={{ textAlign: "left" }}>{item.full_name}</Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant={'body2'} style={{ textAlign: "left" }}>{item.email}</Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant={'body2'} style={{ textAlign: "left" }}>
                                          {item.role === 1 ? "Basic" 
                                            : item.role === 2 ? "Basic Plus" 
                                            : item.role === 3 ? "Investor" 
                                            // : item.role === 4 ? "Investor Plus" 
                                            : item.role === 5 ? "Partnership" 
                                            // : item.role === 6 ? "Partnership Plus" 
                                            : item.role === 7 ? "Enterprise" 
                                            : "--"}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant={'body2'} style={{ textAlign: "left" }}>{moment(item.date).format("DD-MMM-YYYY")}</Typography>
                                      </TableCell>
                                    </TableRow>
                                  )
                                })
                                :
                                <TableRow>
                                  <TableCell colSpan={headCells.length}>
                                    <Typography
                                      style={{ textAlign: 'center', padding: '10px 0px' }}
                                      noWrap
                                      variant={'h4'}>No Records</Typography>
                                  </TableCell>
                                </TableRow>
                            }
                          </TableBody>

                        </Table>
                      </TableContainer>
                      <TablePagination
                        rowsPerPageOptions={config.defaultRowsPerPage}
                        component="div"
                        count={totalUser.total}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </Paper>
                  </Grid>
                </Widget>

              </TabPanel>
              <TabPanel value="2" style={{ padding: "4px" }}>
                <Widget className={classes.boxContainer} noBodyPadding>
                  <Grid item xs={12}>
                    <Paper className={classes.root}>
                      <TableContainer className={classes.container}>
                        <Table
                          aria-labelledby="tableTitle"
                          aria-label="enhanced table">
                          <EnhancedTableHead
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                          // rowCount={users.data.length}
                          />
                          <TableBody>
                            {
                              totalUser.users.length > 0 ?
                                totalUser.users.map((item, index) => {
                                  return (
                                    <TableRow key={index}>
                                      <TableCell
                                        // component="th"
                                        scope="row"
                                        // padding='10px'
                                        width={'10px'}
                                        className={classes.cell}
                                      >
                                        <Typography variant={'body2'}>
                                          {(page * rowsPerPage) + index + 1}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant={'body2'} style={{ textAlign: "left" }}>{item.full_name}</Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant={'body2'} style={{ textAlign: "left" }}>{item.email}</Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant={'body2'} style={{ textAlign: "left" }}>{moment(item.date).format("DD-MMM-YYYY")}</Typography>
                                      </TableCell>
                                    </TableRow>
                                  )
                                })
                                :
                                <TableRow>
                                  <TableCell colSpan={headCells.length}>
                                    <Typography
                                      style={{ textAlign: 'center', padding: '10px 0px' }}
                                      noWrap
                                      variant={'h4'}>No Records</Typography>
                                  </TableCell>
                                </TableRow>
                            }
                          </TableBody>

                        </Table>
                      </TableContainer>
                      <TablePagination
                        rowsPerPageOptions={config.defaultRowsPerPage}
                        component="div"
                        count={totalUser.total}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </Paper>
                  </Grid>
                </Widget>

              </TabPanel>
            </TabContext >
          </Box>
        </Widget>
      )}
      <div
        class="modal fade"
        id="exampleModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="staticBackdropLabel"> Select Date </h5>
              <button
                onClick={() => setTotalUser((prev) => ({ ...prev, selected_date: "" }))}
                type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
              </button>
            </div>
            <div class="modal-body">
              <div className={classes.dateselectionmodaldiv}>
                <label style={{ marginTop: "10px" }} >Start Date</label>
                <Input
                  InputProps={{ inputProps: { max: totalUser.end_date.length > 0 ? totalUser.end_date : "" } }}
                  onChange={(e) => {
                    const val = e.target.value
                    setTotalUser((prev) => ({ ...prev, start_date: val }))
                  }}
                  type='date'
                />
                <label style={{ marginTop: "20px" }} >End Date</label>
                <Input
                  InputProps={{ inputProps: { min: totalUser.start_date.length > 0 ? totalUser.start_date : "" } }}
                  onChange={(e) => {
                    const val = e.target.value
                    setTotalUser((prev) => ({ ...prev, end_date: val }))
                  }}
                  type='date'
                />
              </div>
            </div>
            <div class="modal-footer">
              <button
                disabled={totalUser.end_date.length == 0 || totalUser.start_date.length == 0}
                onClick={onSelectDateclick}
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal">
                Select
              </button>
            </div>
          </div>
        </div>
      </div>
    </Grid >
  )
}

export default withRouter(Subscription);
